import gql from 'graphql-tag';

// Only add fields that do not require user authorization below

export const publicAccountFragment = gql`
  fragment publicAccountFragment on Account {
    dokkioClass
    id
    name
    slug
    description
    squareLogoID
    rectangularLogoID
    rowCreatedAt
    deletedAt
  }
`;
export default publicAccountFragment;
